import { Component, Inject, OnInit } from '@angular/core';
import { ConfigService } from '../../../config/config.service';
import { WebGisApp } from '../../../config/model/app-config.model';
import { MainMapService } from '../../../shared/service/main-map.service';
import { WebgisUrlParameter } from '../share/model/webgis-url-parameter.model';
import { WebgisLink } from '../share/model/webgis-link.model';
import { CONSTANTS } from '../../../config/constants.module';

@Component({
    selector: 'linkTo-webgis-apps',
    templateUrl: './link-to-webgis-apps.component.html',
    styleUrls: ['./link-to-webgis-apps.component.scss'],
    standalone: false
})
export class LinkToWebgisAppsComponent implements OnInit {
  public webGisApps: WebGisApp[];
  public baseUrl: string;

  constructor(
    private _configService: ConfigService,
    private _mainMapService: MainMapService,
    @Inject(CONSTANTS) private CONST: any
  ) {
    this.webGisApps = this._configService.appConfig.webGisApps;
    this.baseUrl = this._configService.baseUrl;
  }

  ngOnInit() {}

  goToWebGisApp(webGisApp: string): string {
    const { extent: currentExtent } = this._mainMapService.mapView.extent;
    if (currentExtent) {
      return this.webgisLink(currentExtent, webGisApp);
    } else {
      return `${this.baseUrl}/${webGisApp}`;
    }
  }

  /**
   * generates a new WebgisLink
   * @param currentExtent the current extent visible on screen
   * @param webGisApp the webgis app name (ex. umwelt)
   */
  private webgisLink(currentExtent: __esri.Extent, webGisApp: string): string {
    const { FUNCTIONS, PARAMETER_NAMES } = this.CONST.APP_URL_PARAMS;
    const functionParam = new WebgisUrlParameter(PARAMETER_NAMES.FUNCTION, FUNCTIONS.ZOOM_TO_WINDOW_AREA);
    const webgisUrlParameterArray: WebgisUrlParameter[] = [];
    webgisUrlParameterArray.push(new WebgisUrlParameter(PARAMETER_NAMES.EASTING1, `${currentExtent.xmin}`));
    webgisUrlParameterArray.push(new WebgisUrlParameter(PARAMETER_NAMES.EASTING2, `${currentExtent.xmax}`));
    webgisUrlParameterArray.push(new WebgisUrlParameter(PARAMETER_NAMES.NORTHING1, `${currentExtent.ymin}`));
    webgisUrlParameterArray.push(new WebgisUrlParameter(PARAMETER_NAMES.NORTHING2, `${currentExtent.ymax}`));

    const webgisLink = new WebgisLink(functionParam, webgisUrlParameterArray);
    const baseUrl = this.resolveWebGisBaseUrl(webGisApp);
    return webgisLink.compositedWebgisLink(baseUrl);
  }

  private resolveWebGisBaseUrl(appName: string): string {
    const stage = this._configService.environment.stage;

    const baseUrls: Record<string, Record<string, string>> = {
      int: {
        umwelt: 'https://umweltgis-int.app.sbb.ch',
        energie: 'https://energie-int.app.sbb.ch',
        rcm: 'https://rcm-video.sbb.ch',
      },
      prod: {
        umwelt: 'https://umweltgis.app.sbb.ch',
        energie: 'https://energie.app.sbb.ch',
        rcm: 'https://rcm-video.sbb.ch',
      },
      DEFAULT: {
        umwelt: 'https://umweltgis-dev.app.sbb.ch',
        energie: 'https://energie-dev.app.sbb.ch',
        rcm: 'https://rcm-video.sbb.ch',
      },
    };

    return (
      baseUrls[stage]?.[appName] ||
      baseUrls['DEFAULT'][appName] ||
      `${this.baseUrl}/${appName}`
    );
  }

}
